import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useSignup } from "../../../contexts/SignupContext";
import { authService } from "../../../services/auth.service";
import styles from "../../../styles/pages/auth/LoginScreen.module.css";

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const { email } = useSignup();

  const [resending, setResending] = useState(false);
  const [resendMessage, setResendMessage] = useState("");

  // Sin email en contexto no hay registro en curso: volver al login.
  useEffect(() => {
    if (!email) navigate("/login", { replace: true });
  }, [email, navigate]);

  if (!email) return null;

  const handleResend = async () => {
    setResending(true);
    setResendMessage("");
    try {
      await authService.resendConfirmation(email);
    } catch (error) {
      console.error(error?.response?.data || error);
    } finally {
      setResending(false);
      // La respuesta del backend es genérica a propósito (no revela si el email existe).
      setResendMessage(
        "Si el correo existe y no está confirmado, te reenviamos el enlace.",
      );
    }
  };

  return (
    <div className={styles.login}>
      <div className={styles.leftLogin} />

      <div className={styles.rightLogin}>
        <div className={styles.successContainer}>
          <div className={styles.successIconWrapper}>
            <svg
              width="52"
              height="52"
              viewBox="0 0 52 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <circle cx="26" cy="26" r="26" fill="#22C55E" />
              <path
                d="M14 26l8 8 16-16"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h1 className={styles.successTitle}>Revisá tu correo</h1>

          <p className={styles.successEmailText}>
            Te enviamos un correo de confirmación a:
            <br />
            <strong>{email}</strong>
          </p>

          <div className={styles.successInfoBox}>
            Hacé clic en el enlace del correo para confirmar tu cuenta y continuar
            con el registro.
          </div>

          <div className={styles.divider} />

          <p className={styles.resendText}>
            ¿No recibiste el correo?{" "}
            <button
              type="button"
              className={styles.resendLink}
              onClick={handleResend}
              disabled={resending}
            >
              {resending ? "Reenviando..." : "Reenviar confirmación"}
            </button>
          </p>

          {resendMessage && (
            <p className={styles.resendText}>{resendMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
}
